import type { AvailableUsersDTO, TeamTypeEnum } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client";

export function useGetAvailableUsers(
  type: TeamTypeEnum,
  teamId?: number,
): UseQueryResult<AvailableUsersDTO, Error> {
  return useQuery({
    queryFn: () =>
      apiClient
        .url("/teams/available-users")
        .query(teamId === undefined ? { type } : { teamId, type })
        .get()
        .json<AvailableUsersDTO>(),
    queryKey: teamsKeys.availableUsers(type, teamId),
  });
}
